<template>
  <div>
    <Label v-if="label">{{ label }}</Label>
    <div class="box-inner box-inner--padding grid grid-cols-8 gap-2">
      <ToolTip
        v-for="color in colors"
        :key="color.name"
        :text="$t('color.' + color.name)"
      >
        <div
          class="relative cursor-pointer hover:scale-105"
          :style="{
            backgroundColor: color.color,
            color: color.textColor,
            paddingTop: '100%',
          }"
          @click="selectedColor = color.name"
        >
          <div
            v-if="selectedColor === color.name"
            class="absolute inset-0 flex items-center justify-center"
          >
            <CheckIcon class="size-6" aria-hidden="true" />
          </div>
        </div>
      </ToolTip>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { CheckIcon } from '@heroicons/vue/24/outline';
import { colors } from '@/util/colors';

const props = defineProps({
  modelValue: {
    type: String,
    required: true,
  },
  label: {
    type: String,
    default: undefined,
  },
});

const emit = defineEmits(['update:modelValue']);

const selectedColor = computed({
  get: () => props.modelValue,
  set: (newValue) => emit('update:modelValue', newValue),
});
</script>
